export default {
  agentList: {
    title: "代理列表",
    serial: "序号",
    agentIdCol: "代理ID",
    type: "代理类型",
    tag: "代理标签",
    typeRequired: "请选择代理类型",
    // 代理类型字典（dict_group_item group 51001）：仅系统预置的三种类型可翻译，
    // 运营自建类型的 agentType 为随机 dataPkCode，会走 defaultValue 保留原文
    typeDict: {
      "51001001": "实体店推广",
      "51001002": "广告推广",
      "51001003": "常规推广",
    },
    name: "代理名称",
    nameRequired: "请输入代理名称",
    account: "代理账号",
    accountRequired: "请输入6~18位的英文加数字组成的代理账号",
    accountPlaceholder: "请输入代理账号",
    domain: "代理域名",
    domainPlaceholder: "请输入域名，如果有多条域名则用，逗号隔开",
    domainFormatError: "只接受有效的域名，不包含 'http://' 或 'https://'",
    inviteCode: "邀请码",
    inviteCodeTitle: "代理邀请码",
    inviteCodeType: "邀请码类型",
    inviteCodeCustom: "自定义邀请码",
    inviteCodeAuto: "系统自动生成",
    inviteCodeRequired: "请输入邀请码",
    inviteCodeRule: "邀请码必须是3-12位数字和字母的组合",
    inviteCodePlaceholder: "请输入由3~12位数字和字母组成的邀请码",
    inviteCodeExist: "你输入的邀请码系统已存在，请更换",
    remark: "备注",
    add: "新增代理",
    addSuccess: "新增成功",
    edit: "编辑代理",
    editSuccess: "修改成功",
    delete: "删除",
    deleteSuccess: "删除成功",
    enabled: "启用",
    enableSuccess: "启用成功",
    disabled: "禁用",
    disableSuccess: "禁用成功",
    lastOpTime: "最后操作时间",
    lastOpUser: "最后操作人",
    confirmDelete: "确定要删除该代理吗？",
    confirmEnable: "确定要启用该代理吗？",
    confirmDisable: "确定要禁用该代理吗？",
    search: "查询",
    reset: "重置",
    all: "全部",
    action: "操作",
    pagination: "共 {total} 条记录 第 {current} / {page} 页",
    accountFormatError: "账号必须是6-18位数字和字母的组合",
    disabledKyc: "禁用注册KYC",
    confirmKycDisable: "是否禁用注册KYC",
    optionFalse: "操作失败",
    confirmKycEnabled: "是否启用注册KYC",
    enabledKyc: "启动注册KYC",
    disabledWithdrawKyc: "禁用提现KYC",
    confirmWithdrawKycDisable: "是否禁用K提现YC",
    confirmWithdrawKycEnabled: "是否启用提现KYC",
    enabledWithdrawKyc: "启动提现KYC",
    agentLevel: "代理层级",
    agentLevelRequired: "请选择代理层级",
    agentLevelTop: "一级代理",
    agentLevelSub: "二级代理",
    agentLevelTip: "一级代理=上级代理，二级代理=普通代理（需指定上级）",
    parentAgent: "上级代理",
    parentAgentRequired: "请选择上级代理",
    parentAgentPlaceholder: "请选择上级代理",
    parentAgentTip: "选择二级代理时必填",
    agentLevelLockedTip: "代理层级一经设定不可修改",
    parentAgentLockedTip: "上级代理一经设定不可修改",
    expandSubAgents: "展开下属二级代理",
    collapseSubAgents: "收起二级代理",
    loginEnable: "启用",
    confirmEnableLogin: "确认要启用该代理登录吗？",
    confirmEnableLoginContent: "启用后该代理将可以正常登录。",
    confirmDisableLogin: "确认要关闭该代理吗？",
    confirmDisableLoginContent: "关闭后该代理将无法登录。",
    optionTrue: "操作成功",
    loginPassword: "登录密码",
    loginPasswordRequired: "请输入登录密码",
    loginPasswordPlaceholder: "≥8位，包含字母+数字",
    loginPasswordRule: "密码至少8位，且必须同时包含字母和数字",
    loginPasswordTip: "代理首次登录使用此密码",
    loginPasswordEditTip: "留空表示不修改；填写则按≥8位字母+数字校验后更新",
    confirmPassword: "确认密码",
    confirmPasswordRequired: "请再次输入登录密码",
    confirmPasswordPlaceholder: "请再次输入登录密码",
    confirmPasswordMismatch: "两次输入的密码不一致"
  },
  agentStats: {
    title: "代理统计",
    phpTab: "PHP",
    vndTab: "VND",
    agentType: "代理类型",
    agentTypePlaceholder: "请选择代理类型",
    agentName: "代理账号",
    agentNamePlaceholder: "请输入代理账号",
    currency: "币种",
    currencyPlaceholder: "请选择币种",
    sequence: "序号",
    loginUserCount: "登录人数",
    registerCount: "会员注册总数量",
    firstRechargeCount: "总首充人数",
    linkClickCount: "代理链接点击量",
    activatedUserCount: "激活人数",
    activatedDepositUserCount: "激活存款人数",
    totalRechargeAmount: "总充值金额",
    totalWithdrawalAmount: "总提现金额",
    betFlow: "有效投注",
    gameAmount: "平台盈亏",
    cost: "渠道总成本",
    registerCost: "注册成本",
    firstRechargeCost: "首存成本",
    costTooltip: "该代理的 \"成本\" 汇总累计值",
    registerCostTooltip: "注册成本= 渠道总成本/总注册人数",
    firstRechargeCostTooltip: "首充成本=渠道总成本/总首存人数",
    currRegisterCost: "当日注册成本",
    currFirstRechargeCost: "当日首充成本",
    currRegisterCostTooltip: "注册成本= 当日成本/注册人数",
    currFirstRechargeCostTooltip: "首充成本=当日成本/首存人数",
    pleaseSearchFirst: "请先进行查询操作",
    riskCount: "风控预警人数",
    riskCountPercent: "预警人数占比",
  },
  // 代理每日游戏分类报告（FBMPLAY-1670）
  agentGameCategoryReport: {
    gameCategory: "游戏分类",
    gameProvider: "游戏供应商",
    memberGroup: "会员数据",
    totalMemberCount: "总人数",
    registerCount: "当天注册",
    rechargeGroup: "充值",
    withdrawGroup: "提款",
    amountCol: "总金额",
    countCol: "人数",
    betCount: "笔数",
    betAmount: "投注",
    payoutAmount: "返奖",
    ggr: "GGR",
    totalGroup: "总计",
    totalBonus: "总优惠",
    totalBet: "总投注",
    totalPayout: "总返奖",
    totalGgr: "总GGR",
    officialDirect: "官网直客",
  },
  agentDailyStats: {
    title: "代理每日业绩",
    day: "日期",
    agentType: "代理类型",
    agentName: "代理账号",
    agentNamePlaceholder: "请输入代理账号",
    loginUserCount: "登录人数",
    registerCount: "注册人数",
    firstRechargeCount: "首充人数",
    firstDepositAmount: "首存金额",
    rechargeCount: "充值人数",
    rechargeAmount: "充值金额",
    linkClickCount: "代理链接点击量",
    activatedUserCount: "激活人数",
    activatedDepositUserCount: "激活存款人数",
    withdrawalCount: "提现人数",
    withdrawalAmount: "提现金额",
    betFlow: "有效投注",
    gameAmount: "平台盈亏",
    betAmount: "投注金额",
    payoutAmount: "返奖金额",
    ggr: "GGR",
    netAmount: "出入款盈亏",
    pleaseSearchFirst: "请先进行查询操作"
  },
  agentCostStats: {
    title: "推广成本",
    day: "日期",
    agentType: "代理类型",
    agentName: "代理帐号",
    agentNamePlaceholder: "请输入代理名称",
    registerCount: "注册人数",
    rechargeCount: "充值人数",
    rechargeAmount: "充值金额",
    withdrawalCount: "提现人数",
    withdrawalAmount: "提现金额",
    profit: "出入款盈亏",
    cost: "成本",
    returnRate: "成本回报率",
    paybackDays: "回本天数（天）",
    action: "操作",
    editCost: "成本",
    editCostModalTitle: "编辑成本",
    costLabel: "成本金额",
    costPlaceholder: "请输入成本金额",
    costRequired: "请输入成本金额",
    costMinValue: "成本金额不能小于0",
    updateCostSuccess: "成本修改成功",
    pleaseSearchFirst: "请先进行查询操作",
    dateRangeExceeds31Days: "时间范围不能超过31天"
  },
  agentTodayData: {
    title: "今日代理数据",
    levelTop: "一级",
    levelSub: "二级",
    levelSelf: "直属",
    aggregatedSuffix: "（汇总）",
    agentAccount: '代理账号',
    search: '查询',
    pleaseEnterAgentAccount: '请输入代理账号',
    agentAccountNotFound: '你输入的代理账号不存在，请重新输入',
    noData: '暂无数据，请先查询代理',
    registerCount: '注册人数',
    firstRechargeCount: '首充人数',
    rechargeCount: '充值人数',
    withdrawalCount: '提现人数',
    profit: '出入款盈亏',
    firstRechargeAmount: '首充金额',
    rechargeAmount: '充值金额',
    withdrawalAmount: '提现金额',
    agentAccountDigitsOnly: '代理账号只能是数字',
  },
  agentTag: {
    title: "代理标签",
    serial: "序号",
    tagName: "标签名称",
    tagNameRequired: "请输入标签名称",
    tagNamePlaceholder: "请输入",
    remark: "备注",
    remarkPlaceholder: "请输入",
    lastOpTime: "最后操作时间",
    lastOpUser: "最后操作人",
    action: "操作",
    add: "新增代理标签",
    addSuccess: "新增成功",
    edit: "修改",
    editSuccess: "修改成功",
    delete: "删除",
    deleteSuccess: "删除成功",
    confirmDelete: "确定要删除该标签吗？",
    search: "查询",
    reset: "重置",
    pagination: "共 {total} 条记录 第 {current} / {page} 页",
  },
  agentTransfer: {
    // 顶部 tabs
    tab_transfer: "代理转移",
    tab_history: "转移记录",
    tab_game_category: "代理每日游戏分类报告",
    // 左侧侧栏 (AgentTreeSidebar)
    sidebar_search_placeholder: "搜索代理账号",
    sidebar_empty: "暂无代理",
    sidebar_tag_l1: "一级",
    sidebar_tag_l2: "二级",
    sidebar_subagent_count_tooltip: "名下二级 {count} 个",
    sidebar_loading: "加载中…",
    sidebar_no_subagents: "无二级代理",
    // 右侧空态
    empty_select_l1: "请在左侧选择一级代理",
    empty_select_l2: "请在左侧选择二级代理",
    // 一级代理面板 (AgentTransferTab)
    tag_top_agent: "一级代理",
    tag_sub_agent: "二级代理",
    stat_sub_count: "名下二级",
    stat_direct_member: "直属会员",
    btn_demote_to_l2: "降级为二级",
    card_subagent_list: "名下二级代理",
    col_agent_account: "代理账号",
    col_agent_name: "代理名称",
    col_action: "操作",
    btn_transfer: "转移",
    empty_no_subagent_for_l1: "该一级代理名下暂无二级代理",
    member_count_unit_suffix: "人",
    card_direct_member: "直属会员",
    card_recent_log: "最近转移记录",
    btn_view_all_log: "查看全部记录",
    no_recent_log: "暂无记录",
    log_upgrade_text: "{account} 从二级升为一级",
    log_demote_text: "{account} 从一级降为二级，挂入 {target}",
    log_transfer_text: "{account} 从 {from} → {to}",
    // 降级前置告警
    demote_blocked_title: "无法直接降级",
    demote_blocked_line1: "该一级代理名下仍有 {count} 个二级代理，无法直接降级。",
    demote_blocked_line2: "请先将二级代理转移至其他一级代理名下，再执行降级操作。",
    // 二级代理面板 (SubAgentDetailPanel)
    sub_panel_parent_l1: "所属一级：",
    sub_panel_member_count: "名下会员",
    btn_transfer_to_other_l1: "转移到其他一级",
    btn_upgrade_to_l1: "升级为一级",
    // 会员列表 (AgentMemberListCard)
    member_card_title_default: "名下会员",
    member_col_account: "会员账号",
    member_col_vip: "会员等级",
    member_col_deposit: "累计充值",
    member_col_last_login: "最后登录",
    member_col_status: "状态",
    member_status_active: "活跃",
    member_status_inactive: "不活跃",
    member_empty: "该代理名下暂无会员",
    member_total: "共 {total} 条",
    member_load_fail: "加载会员列表失败",
    // 转移弹窗
    transfer_modal_title: "转移二级代理",
    transfer_modal_ok: "确认转移",
    modal_cancel: "取消",
    modal_label_account: "代理账号：",
    modal_label_name: "代理名称：",
    modal_label_current_parent: "当前归属：",
    modal_label_member_count: "名下会员：",
    transfer_info_member_count: "名下会员",
    transfer_info_follow: "全部跟随转移至目标一级",
    transfer_field_target: "目标一级代理",
    transfer_field_target_required: "请选择目标一级代理",
    transfer_field_target_placeholder: "请选择目标一级代理",
    transfer_field_reason: "转移原因",
    transfer_field_reason_required: "请输入转移原因",
    transfer_field_reason_placeholder: "请输入转移原因",
    transfer_impact_title: "转移后影响：",
    transfer_impact_1: "1. 该二级代理改挂到目标一级名下，名下会员仍归属该二级代理不变",
    transfer_impact_2_a: "2. 会员的直接归属代理不变，只是上层一级从「",
    transfer_impact_2_b: "」变为目标一级",
    transfer_impact_3: "3. 历史投注/充提记录保留原始归属，不回溯修改",
    transfer_impact_4: "4. 转移后产生的新数据按新归属统计",
    transfer_impact_5: "5. 原一级与目标一级的注册、充值、提现、有效投注、盈亏等向上汇总数据将重新计算",
    transfer_alert: "该代理名下所有会员全部跟随转移 · 不会产生会员多归属或无归属 · 操作不可撤销",
    // 升级弹窗
    upgrade_modal_title: "升级为一级代理",
    upgrade_modal_ok: "确认升级",
    upgrade_current: "当前：",
    upgrade_info_follow: "全部跟随升级为新一级直属",
    upgrade_impact_title: "升级后影响：",
    upgrade_impact_1: "1. 该代理身份从二级变为一级，脱离原一级代理管辖，成为独立一级",
    upgrade_impact_2_bold: "名下所有会员 → 全部跟随",
    upgrade_impact_2_post: "，从「二级名下会员」变成「新一级直属会员」",
    upgrade_impact_3: "3. 会员归属代理不变（还是同一个代理），只是代理的层级升了",
    upgrade_impact_4: "4. 邀请码保留不变，新增特权：可配置代理域名",
    upgrade_impact_5: "5. 原一级代理的注册、充值、提现、有效投注、盈亏等向上汇总数据将全量重新计算",
    upgrade_impact_note: "不会产生冲突：会员归属的代理没有变化，只是代理身份升级了",
    upgrade_field_reason: "升级原因",
    upgrade_field_reason_required: "请输入升级原因",
    upgrade_field_reason_placeholder: "如：业务扩展、独立运营等",
    upgrade_success_alert_prefix: "✅ 升级后成为独立一级代理 · 名下所有会员全部跟随 · 邀请码保留不变 · 新增代理域名配置 · ",
    upgrade_success_alert_bold: "操作不可撤销",
    // 降级弹窗
    demote_modal_title: "降级为二级代理",
    demote_modal_ok: "确认降级",
    demote_label_current: "当前代理：",
    demote_label_current_tier: "当前层级：",
    demote_label_after_tier: "降级后：",
    demote_field_new_parent: "新上级一级代理",
    demote_field_new_parent_required: "请选择新上级一级代理",
    demote_field_new_parent_placeholder: "请选择降级后挂入哪个一级代理名下",
    demote_field_reason: "降级原因",
    demote_field_reason_required: "请输入降级原因",
    demote_field_reason_placeholder: "请输入降级原因",
    demote_impact_title: "降级后影响：",
    demote_impact_1: "1. 该代理层级由「一级」变为「二级」，挂在目标一级代理名下",
    demote_impact_2: "2. 该代理名下原本的直属会员保持归属不变（自动跟随）",
    demote_impact_3: "3. 邀请码与代理域名保持不变，新会员仍可通过原渠道注册到该代理",
    demote_impact_4: "4. 历史投注 / 充提记录保留原始归属，不回溯修改",
    demote_alert: "操作不可撤销 · 降级后该代理将无法再以一级身份接收新二级代理 · 如需恢复请联系管理员",
    // 顶层 message 提示
    msg_load_agent_list_fail: "加载代理列表失败",
    msg_load_subagent_fail: "加载二级代理失败",
    msg_transfer_success: "{account} 已转移至 {target}",
    msg_transfer_fail: "转移失败",
    msg_upgrade_success: "{account} 已升级为一级代理",
    msg_upgrade_fail: "升级失败",
    msg_demote_success: "{account} 已降级，挂入 {target}",
    msg_demote_fail: "降级失败",
  },
  transferLog: {
    // header / chip
    related_top_agent: "相关一级代理",
    related_top_agent_hint: "（仅显示与该一级代理相关的转移 / 降级 / 升级记录）",
    // 筛选
    filter_transfer_type: "操作类型",
    filter_transfer_type_placeholder: "全部",
    filter_agent_account: "代理账号",
    filter_agent_account_placeholder: "被操作的代理",
    filter_from_parent: "原一级",
    filter_from_parent_placeholder: "原上级一级账号",
    filter_to_parent: "新一级",
    filter_to_parent_placeholder: "新上级一级账号",
    filter_date_range: "操作时间",
    // 按钮 / 提示
    search: "查询",
    reset: "重置",
    query_fail: "查询失败",
    // 操作类型 tag
    type_transfer: "转移",
    type_demote: "降级",
    type_upgrade: "升级",
    // 表格列
    col_record_id: "记录ID",
    col_transfer_type: "操作类型",
    col_agent_account: "代理账号",
    col_from: "原归属",
    col_to: "新归属",
    col_reason: "原因",
    col_operator: "操作人",
    col_create_time: "操作时间",
    // 层级
    tier_l1: "一级",
    tier_l2: "二级",
    // 分页
    total: "共 {total} 条",
  },
  agentType: {
    title: "代理类型",
    serial: "序号",
    typeName: "类型名称",
    typeNameRequired: "请输入类型名称",
    typeNamePlaceholder: "请输入",
    typeDesc: "类型描述",
    typeDescRequired: "请输入类型描述",
    typeDescPlaceholder: "请输入",
    lastOpTime: "最后操作时间",
    lastOpUser: "最后操作人",
    action: "操作",
    add: "新增",
    addSuccess: "新增成功",
    edit: "编辑",
    editSuccess: "修改成功",
    delete: "删除",
    deleteSuccess: "删除成功",
    confirmDelete: "确定要删除该类型吗？",
    search: "查询",
    reset: "重置",
    pagination: "共 {total} 条记录 第 {current} / {page} 页",
  }
};
